export const TESTIMONIALS = [
  {
    quote:
      "Burly's apron-front sinks have been the quiet star of our last four projects. The glaze holds up after years of red-wine spills and cast-iron knocks.",
    author: "Marta Schaeffer",
  },
  {
    quote:
      "We've sourced fireclay for two decades. The body density and dimensional consistency from Burly is class-leading.",
    author: "Daniel Roche",
  },
  {
    quote:
      "Our private-label kitchen line ships in eleven countries. Burly's team manages packaging, labelling, and freight, we just sell.",
    author: "Aiko Tanaka",
  },
];

export const CERTIFICATIONS = [
  { code: "ISO 9001:2015", desc: "Quality Management Systems" },
  { code: "ISO 14001:2015", desc: "Environmental Management" },
  { code: "CE Marking", desc: "European Conformity (EN 13310)" },
  { code: "cUPC", desc: "Certified under standard B45" },
  { code: "WRAS Approved", desc: "Water Regulations Advisory Scheme (UK)" },
  { code: "BIS Certified", desc: "Bureau of Indian Standards" },
];

export const WHY_BURLY = [
  {
    title: "Designed in the USA",
    body:
      "Burly's product direction starts in New Jersey, apron styles, finishes, and proportions tuned for North American kitchens.",
  },
  {
    title: "Crafted in India",
    body:
      "Slip preparation, casting, glazing, firing, and quality control under one roof at our own plant. No outsourcing, no white-labeling.",
  },
  {
    title: "Engineered for global kitchens",
    body:
      "From kiln to container. We handle export packaging, paperwork, and after-sale support for our partners abroad.",
  },
  {
    title: "10-year warranty",
    body:
      "Every Burly sink is warranted for a decade against manufacturing defects.",
  },
];

export const MANUFACTURING_STEPS = [
  {
    n: "01",
    title: "Slip preparation",
    body:
      "Kaolin, ball clay, German chamotte, feldspar, and silica are blended into a liquid slip with controlled viscosity and specific gravity.",
  },
  {
    n: "02",
    title: "Slip casting",
    body:
      "Slip is poured into plaster moulds. As water draws into the plaster, a 12 mm to 45 mm fireclay wall builds against the mould.",
  },
  {
    n: "03",
    title: "Greenware curing",
    body:
      "Castings cure for 72 hours under controlled humidity to prevent micro cracks before the first bisque firing.",
  },
  {
    n: "04",
    title: "Bisque firing",
    body:
      "An initial low temperature firing hardens the body, preparing it for glaze adhesion.",
  },
  {
    n: "05",
    title: "Glaze application",
    body:
      "Glaze is hand sprayed in even passes by trained applicators, never dipped, never machine painted.",
  },
  {
    n: "06",
    title: "Final fire at 1,250°C",
    body:
      "The vitrifying fire fuses glaze and body into a single ceramic surface, non-porous, acid-resistant, and lifelong.",
  },
];
